import React from "react";
import "./BannerWithCards.scss";
import BackgroundImageCard from "../@shared/BackgroundImageCard";
import BannerBox from "./BannerBox/BannerBox";
import { trackWithGoogleTagManager } from "../../utils/analytics";
import withErrorCatch from "../../helper/withErrorCatch";

const BannerWithCards = (props: any) => {
  if (!props.fields) {
    return <></>;
  }
  const track: (
    eventLabel: string,
    eventAction: string,
    eventCategory: string,
    event: string
  ) => void = (eventLabel, eventAction, eventCategory, event) => {
    trackWithGoogleTagManager({
      event,
      eventCategory,
      eventAction,
      eventLabel,
    });
  };
  const createDropdownData = (dropdownData: string) => {
    if (typeof dropdownData !== "string" || !dropdownData.split) {
      return {};
    }

    let items = dropdownData?.split("&").map((item) => {
      return item.split("=");
    });

    return items?.map((item) => {
      let value = "";
      value += decodeURI(item[1])?.replace("%2F", "/");
      return {
        Name: item[0],
        Value: value,
      };
    });
  };

  const networkCard = props.fields.bannerList[0];
  const networkData = {
    title: props.fields.title,
    subtitle: props.fields.boxTitle,
    imageHeading: networkCard.title?.value,
    image: networkCard.image,
    cardIcon: networkCard?.icon.fields?.["Icon Css Class"]?.value,
    cardContent: (
      <>
        <BannerBox
          boxTitle={networkCard.boxTitle}
          boxDescription={networkCard.boxDescription}
          ctaText={networkCard.moreInformationButtonTitle}
          searchBoxTitle={networkCard.searchBoxTitle}
          searchDropdownOne={{
            title: networkCard.searchBoxDropDown1Title,
            placeholder: networkCard.searchBoxDropDown1Placeholder,
          }}
          searchDropdownTwo={{
            title: networkCard.searchBoxDropDown2Title,
            placeholder: networkCard.searchBoxDropDown2Placeholder,
            data:
              typeof networkCard.searchBoxDropDown2Data?.value === "string"
                ? createDropdownData(networkCard.searchBoxDropDown2Data?.value)
                : networkCard.searchBoxDropDown2Data?.value,
          }}
          searchDropdownThree={{
            title: networkCard.searchBoxDropDown3Title,
            placeholder: networkCard.searchBoxDropDown3Placeholder,
            data:
              typeof networkCard.searchBoxDropDown3Data?.value === "string"
                ? createDropdownData(networkCard.searchBoxDropDown3Data?.value)
                : networkCard.searchBoxDropDown3Data?.value,
          }}
          searchButton={networkCard.searchButton}
          firstInput={true}
          buttonDisabled={true}
          gaTrack={() => {
            track(
              "dealer_locator",
              "dealer_locator",
              "dealer_locator",
              "event_dealer_locator"
            );
          }}
          useDirectLink={networkCard?.useDirectLink}
        />
      </>
    ),
  };
  const engineCard = props.fields.bannerList[1];
  const engineData = {
    imageHeading: engineCard.title?.value,
    ctaText: engineCard.moreInformationButtonTitle,
    image: engineCard.image,
    cardIcon: engineCard?.icon.fields?.["Icon Css Class"]?.value,
    cardContent: (
      <>
        <BannerBox
          boxTitle={engineCard.boxTitle}
          boxDescription={engineCard.boxDescription}
          ctaText={engineCard.moreInformationButtonTitle}
          searchBoxTitle={engineCard.searchBoxTitle}
          data={engineCard.data}
          searchDropdownOne={{
            title: engineCard?.searchBoxDropDown1Title,
            placeholder: engineCard.searchBoxDropDown1Placeholder,
          }}
          searchDropdownTwo={{
            title: engineCard?.searchBoxDropDown2Title,
            placeholder: engineCard.searchBoxDropDown2Placeholder,
          }}
          searchDropdownThree={{
            title: engineCard.searchBoxDropDown3Title,
            placeholder: engineCard.searchBoxDropDown3Placeholder,
          }}
          searchButton={engineCard.searchButton}
          firstInput={false}
          buttonDisabled={false}
          gaTrack={() => {
            track(
              "find_your_engine",
              "find_your_engine",
              "find_your_engine",
              "event_find_your_engine"
            );
          }}
          useDirectLink={engineCard?.useDirectLink}
        />
      </>
    ),
  };
  return (
    <div className={"BannerWithCards__wrapper"}>
      <BackgroundImageCard
        titleColor="white"
        hiddenBox={true}
        fields={networkData}
      />
      <BackgroundImageCard hiddenBox={true} fields={engineData} />
    </div>
  );
};

export default withErrorCatch(BannerWithCards);
